import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { LanguageProvider } from './i18n/LanguageContext';
// Metricool tracking hash for Blinkblis
const METRICOOL_HASH = 'df4ba11b5f84ffc1f3c2fca17f7e75d4';
export function App() {
  useEffect(() => {
    // Avoid injecting the tracker more than once
    if (document.getElementById('metricool-tracker')) return;
    const script = document.createElement('script');
    script.id = 'metricool-tracker';
    script.type = 'text/javascript';
    script.src = 'https://tracker.metricool.com/resources/be.js';
    const init = () => {
      const w = window as unknown as {
        beTracker?: {
          t: (opts: {
            hash: string;
          }) => void;
        };
      };
      if (w.beTracker) {
        w.beTracker.t({
          hash: METRICOOL_HASH
        });
      }
    };
    script.onload = init;
    (script as any).onreadystatechange = init;
    document.getElementsByTagName('head')[0].appendChild(script);
  }, []);
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}